module.exports = __webpack_public_path__ + "img/place-3.725289b7.svg";